import { render, staticRenderFns } from "./InvoiceDetail.vue?vue&type=template&id=0877936c&scoped=true&"
import script from "./InvoiceDetail.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDetail.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceDetail.vue?vue&type=style&index=0&id=0877936c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0877936c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0877936c')) {
      api.createRecord('0877936c', component.options)
    } else {
      api.reload('0877936c', component.options)
    }
    module.hot.accept("./InvoiceDetail.vue?vue&type=template&id=0877936c&scoped=true&", function () {
      api.rerender('0877936c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_invoices/InvoiceDetail.vue"
export default component.exports